// Generate code from clean architecture template

import { CourseLineEntity } from '@/domains/course-lines/entities';
import {
  CourseLinePayloadForm,
  QueryCourseLinePayload,
  QueryCourseLinesOutput,
} from '@/domains/course-lines/ports/payloads';
import { CourseLineRepository } from '@/domains/course-lines/ports/repositories';
import { HttpClientAdapter } from '@/graphql/http-client-adapter';
import {
  CREATE_COURSE_LINE,
  DETAIL_COURSE_LINE,
  GET_COURSE_LINE_ITEMS,
  UPDATE_COURSE_LINE,
} from '../../graphql';

export class CourseLineHttpRepository implements CourseLineRepository {
  async getListCourseLine(payload?: QueryCourseLinePayload): Promise<QueryCourseLinesOutput> {
    const response: QueryCourseLinesOutput = await HttpClientAdapter.query<QueryCourseLinesOutput>({
      query: GET_COURSE_LINE_ITEMS,
      dataKey: 'CourseLine_getList',
      variables: { query: { sortBy: ['lastModifiedAt|desc', '_id|desc'], ...payload } },
    });
    return response;
  }

  async createCourseLine(payload: CourseLinePayloadForm): Promise<CourseLineEntity> {
    const response = await HttpClientAdapter.mutate<CourseLineEntity>({
      mutation: CREATE_COURSE_LINE,
      variables: { payload: payload },
    });
    return response;
  }

  async updateCourseLine(payload: CourseLinePayloadForm): Promise<CourseLineEntity> {
    const response: CourseLineEntity = await HttpClientAdapter.mutate<CourseLineEntity>({
      mutation: UPDATE_COURSE_LINE,
      variables: { payload: payload },
    });
    return response;
  }

  async getDetailCourseLine(payload: string): Promise<CourseLineEntity> {
    const response: CourseLineEntity = await HttpClientAdapter.query<CourseLineEntity>({
      query: DETAIL_COURSE_LINE,
      dataKey: 'CourseLine_getById',
      variables: { id: payload },
    });
    return response;
  }
}
